export enum AwApiTarget {
	USERS_API = "/users",
	REFRESH_TOKEN = "/api/token/refresh",
};
